import {
  BedDouble,
  Briefcase,
  CalendarCheck,
  Coffee,
  Plane,
  ShieldCheck,
} from 'lucide-react'
import type { HotelProfile, HotelService } from '../api/types'

const ICON_MAP: Record<string, typeof BedDouble> = {
  'bed-double': BedDouble,
  'calendar-check': CalendarCheck,
  plane: Plane,
  'shield-check': ShieldCheck,
  coffee: Coffee,
  briefcase: Briefcase,
}

// Keep at most 4 "pillars" — dense homepages read as noise.
const MAX_PILLARS = 4

export function EssenceSection({ hotel }: { hotel: HotelProfile }) {
  if (!hotel.about_title && (!hotel.services || hotel.services.length === 0)) return null
  // Dedupe by title — seed data sometimes ships repeats of the same pillar.
  const seen = new Set<string>()
  const pillars: HotelService[] = (hotel.services || [])
    .slice()
    .sort((a, b) => a.order - b.order)
    .filter((s) => {
      const key = s.title.trim().toLowerCase()
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
    .slice(0, MAX_PILLARS)

  return (
    <section className="essence-section" id="about" aria-labelledby="essence-heading">
      <div className="essence-grid">
        <div className="essence-narrative reveal-on-scroll">
          <span className="eyebrow">{hotel.about_title || 'Nuestra esencia'}</span>
          <h2 id="essence-heading">{hotel.hotel_name}</h2>
          {hotel.about_description && (
            <p className="essence-lede">{hotel.about_description}</p>
          )}
        </div>
        {pillars.length > 0 && (
          <ul className="essence-pillars" aria-label="Lo que nos distingue">
            {pillars.map((p, i) => {
              const Icon = ICON_MAP[p.icon] || ShieldCheck
              return (
                <li
                  key={p.id}
                  className="essence-pillar reveal-on-scroll"
                  style={{ ['--i' as string]: i } as React.CSSProperties}
                >
                  <Icon size={22} aria-hidden />
                  <span>{p.title}</span>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </section>
  )
}
